import axios from "axios";

export const ndeFormInstance = axios.create({
  // baseURL: "http://localhost:4000",
    baseURL: "https://eojpzxt893.execute-api.ap-south-1.amazonaws.com",
});

// Add a request interceptor
ndeFormInstance.interceptors.request.use(
  function (config) {
    if (sessionStorage.getItem('utm_source')) {
        config.data.utm_source = sessionStorage.getItem('utm_source');
    }
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
ndeFormInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
